import { render, staticRenderFns } from "./DataXueYang.vue?vue&type=template&id=19efb661&"
import script from "./DataXueYang.vue?vue&type=script&lang=js&"
export * from "./DataXueYang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports